<template>
<div class="menuBody" >
    <BillManTree @AllData="getMsgFormSon" @NodeData="NodeData" />
        <BillManagerDialog :param="diaLogData" @Visible="Visible" ref="BillManagerDialog"/>
    <div class="menuTool" >
      <el-card class="box-card">
        <el-row >
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据管理人员列表  
            </div>
             <div style="width:200px;float:left;margin-right:30px">
                 <el-input placeholder="请输入票据管理人员名称" size="small"     v-model="groupName"></el-input>
            </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:bs:bms:selectListPage'" @click="Inquire()">查询</el-button>
            </div>
            <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" v-show="this.mangroupId !='' " size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:bs:bms:save'" @click="PropertyAdd()">票据管理人员添加</el-button>
            </div>
              <el-table  :data="tableData" v-loading="loading" tooltip-effect="light"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"   style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="userName" label="票据管理人员名称" >
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="putIn" label="入库处理">
           <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.putIn=='0'" >否</el-tag>
            <el-tag type="success" v-if="scope.row.putIn=='1'" >是</el-tag>
        </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="takeOut" label="领用处理">
             <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.takeOut=='0'" >否</el-tag>
            <el-tag type="success" v-if="scope.row.takeOut=='1'" >是</el-tag>
        </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="cancelAfter" label="核销处理">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.cancelAfter=='0'" >否</el-tag>
            <el-tag type="success" v-if="scope.row.cancelAfter=='1'" >是</el-tag>
        </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="certification" label="凭证审核">
         <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.certification=='0'" >否</el-tag>
            <el-tag type="success" v-if="scope.row.certification=='1'" >是</el-tag>
        </template>
    </el-table-column>
      <el-table-column show-overflow-tooltip prop="remarks" label="备注"></el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle v-Jurisdiction="'expense:web:bs:bms:save'" size="small" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle v-Jurisdiction="'expense:web:bs:bms:delete'" size="small" title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import BillManagerDialog from "../common/BillManagerDialog";
import BillManTree from "../common/BillManTree.vue";

export default {
  name: "BillManager",
  components: {BillManagerDialog,BillManTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        groupNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
      ManagerData:{},
    }
  },
  methods: {
    AmountChange(){
    //   console.log(this.amountval)
      var arr = this.amountval
      var ende = arr[arr.length-1]
      // console.log(ende);
      for(let val of this.amount){
        if(this.amountval == val.value){
          // console.log(val)
          this.taxRateval = val.value
          this.taxRatelab = val.label
        }else{
          var end = arr[0]
          // console.log(end);
          if(end == val.value){
            // console.log(val)
            for(let arr of val.children){
              if(ende == arr.value){
                // console.log(arr)
                  this.taxRateval = arr.value
                  this.taxRatelab = arr.label
              }
            }
          }
        }
      }
    },
    dialog(data){
      if(data == false){
        this.SharList()
      }
    },
    expend(){
    },
    handleSelectionChange(val){
      this.USERObj= val
    },
    getMsgFormSon(data){
      this.AllData = data
    },
    NodeData(data){
      this.loading = true
      this.ManagerData = data
        this.mangroupId = data.Pid
        this.mangrouplab = data.label
        this.SharList()
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.SharList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.SharList()
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "userName":this.groupName,
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILL_MANAGERLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.tableData = data.data.records;
            this.groupName = ""
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      
    },
    PropertyAdd(){
        // 添加项目
        if(this.USERObj.length == 0){
      this.$refs.BillManagerDialog.title = "添加";
      this.$refs.BillManagerDialog.dialogVisible = true; 
      this.$refs.BillManagerDialog.options = this.AllData;
      this.$refs.BillManagerDialog.putInval =""
      this.$refs.BillManagerDialog.takeOutval =""
      this.$refs.BillManagerDialog.cancelAfterval =""
      this.$refs.BillManagerDialog.certificationval =""
      this.$refs.BillManagerDialog.value =""
      this.$refs.BillManagerDialog.valueone = ""
          let obj = {
            "mangroupName":"票据管理组",
            "userName":"票据管理人名称",
            "putIn":"入库权限",
            "takeOut":"领用权限",
            "cancelAfter":"核销权限",
            "certification":"凭证审核",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
         this.$refs.BillManagerDialog.formLabelAlign= row;
        }
    },
    SharList(){
       let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILL_MANAGERLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    editMenu(row) { // 修改
    // console.log(row)
    let arr = []
    let opobj = {}
    opobj.userName = row.userName
    opobj.userId = row.userId
    arr.push(opobj)
    let array = []
    array.push(opobj.userId)
    let listA = []
    listA.push(row.userName)
      this.$refs.BillManagerDialog.title = "修改";
      this.$refs.BillManagerDialog.dialogVisible = true;
      this.$refs.BillManagerDialog.options = this.AllData;
      this.$refs.BillManagerDialog.putInval = row.putIn;
      this.$refs.BillManagerDialog.takeOutval = row.takeOut;
      this.$refs.BillManagerDialog.cancelAfterval = row.cancelAfter;
      this.$refs.BillManagerDialog.certificationval = row.certification;
      this.$refs.BillManagerDialog.value = this.mangrouplab
      this.$refs.BillManagerDialog.mangroupId = this.mangrouplab
      this.$refs.BillManagerDialog.optionsone = arr
      this.$refs.BillManagerDialog.valueone = array
      this.$refs.BillManagerDialog.userIdArr = array
      this.$refs.BillManagerDialog.officeId = row.officeId
      this.$refs.BillManagerDialog.officeName = row.officeName
      this.$refs.BillManagerDialog.userNameArr = listA
        let obj = {
            "mangroupName":"票据管理组",
            "userName":"票据管理人名称",
            "putIn":"入库权限",
            "takeOut":"领用权限",
            "cancelAfter":"核销权限",
            "certification":"凭证审核",
            "remarks":"备注信息",
          }
        row.obj = obj
         this.$refs.BillManagerDialog.formLabelAlign= row;
        },
    delMenu(row){
        this.$confirm('是否确认要删除该人员?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      this.$http.post(this.$requestUrl.DELETE_BILL_MANAGER+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.SharList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
        Visible(data){
      if(data == false){
        this.loading = true
        this.SharList();
      }
    }

  },
  mounted() {
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>